var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3968 19.1039C18.5922 19.299 18.9088 19.2987 19.1039 19.1032C19.299 18.9078 19.2987 18.5912 19.1032 18.3961L18.3968 19.1039ZM11.2212 16.6923C8.19952 16.6923 5.75 14.2428 5.75 11.2212H4.75C4.75 14.7951 7.64723 17.6923 11.2212 17.6923V16.6923ZM5.75 11.2212C5.75 8.19952 8.19952 5.75 11.2212 5.75V4.75C7.64723 4.75 4.75 7.64723 4.75 11.2212H5.75ZM11.2212 5.75C14.2428 5.75 16.6923 8.19952 16.6923 11.2212H17.6923C17.6923 7.64723 14.7951 4.75 11.2212 4.75V5.75ZM16.6923 11.2212C16.6923 12.7335 16.0793 14.1018 15.0871 15.0926L15.7937 15.8002C16.9661 14.6295 17.6923 13.0097 17.6923 11.2212H16.6923ZM15.0871 15.0926C14.0966 16.0816 12.7307 16.6923 11.2212 16.6923V17.6923C13.0063 17.6923 14.6234 16.9688 15.7937 15.8002L15.0871 15.0926ZM15.0871 15.8003L18.3968 19.1039L19.1032 18.3961L15.7936 15.0926L15.0871 15.8003Z",
    fill: "#999CA0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dc4af308e377c4329d6d840cd2ac982c.svg";
export { ForwardRef as ReactComponent };